exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sortable[data-v-18c60b82] { list-style-type: none; margin: 0; padding: 0;\n}\n.sortable li[data-v-18c60b82] { margin: 3px 3px 3px 3px; padding: 0.5em; padding-left: 1.5em; font-size: 14px; background: #fff;border-radius: 5px !important;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);}\ntable.grid[data-v-18c60b82] {\n    width: 100%;\n    border: none;\n    background-color: #d9edf7;\n    color: #333;\n    padding: 0px;\n    text-align: center;\n}\ntable.grid td[data-v-18c60b82]{\n    border: 4px solid white;\n}\n.text-blob[data-v-18c60b82]{\n    font-weight: bold;\n}\n", ""]);

// exports
